import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RdService } from 'src/app/services/rd.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  financialYearStart: number;
  financialYearEnd: number;
  constructor(public rdService: RdService, private route: ActivatedRoute, private router: Router) { }
  ngOnInit(): void {
    this.FinancialYearCalculate();
  }
  FinancialYearCalculate()
  {
    const currentDate = new Date();
    // Get the current year
    const currentYear = currentDate.getFullYear();
    // Determine the financial year based on the current date
    if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
      // If before April 1st, the financial year started in the previous year
      this.financialYearStart = currentYear - 1;
      this.financialYearEnd = currentYear;
    } else {
      // If on or after April 1st, the financial year started in the current year
      this.financialYearStart = currentYear;
      this.financialYearEnd = currentYear + 1;
    }
  }

  get showOptOutBtn(): boolean {
  const url = this.router.url;

  // 1. URL survey-start hona chahiye
  const isSurveyStart = url.includes('/survey/survey-start');

  // 2. Query params check
  const params = this.route.snapshot.queryParams;

  const hasParams =
    params['utype'] !== undefined ||
    params['tforid'] !== undefined ||
    params['qparm'] !== undefined ||
    params['sid'] !== undefined ||
    params['transid'] !== undefined;

  return isSurveyStart && hasParams;
}

onReject(){
  window.dispatchEvent(new CustomEvent('triggerRejectAction'));
}
}
